import { getDocument, GlobalWorkerOptions } from "pdfjs-dist";

const checkPDFPasswordProtected = async (file) => {
  if (!(file instanceof Blob)) {
    console.error("Input is not a Blob or File object.");
    return Promise.resolve(null);
  }

  // Set workerSrc correctly (safe way for React/Webpack)
  if (!GlobalWorkerOptions.workerSrc) {
    GlobalWorkerOptions.workerSrc = new URL(
      "pdfjs-dist/build/pdf.worker.min.mjs",
      import.meta.url
    ).toString();
  }

  const reader = new FileReader();

  return new Promise((resolve) => {
    reader.onload = async () => {
      const typedarray = new Uint8Array(reader.result);
      try {
        await getDocument({ data: typedarray }).promise;
        resolve(false); // PDF is not password-protected
      } catch (error) {
        if (error?.name === "PasswordException") {
          resolve(true); // PDF is password-protected
        } else {
          console.error("Unexpected PDF error:", error);
          resolve(null); // Unknown or unreadable file
        }
      }
    };

    reader.onerror = (e) => {
      console.error("File reading error:", e);
      resolve(null);
    };

    reader.readAsArrayBuffer(file);
  });
};

export default checkPDFPasswordProtected;
